import {
  ADD_HOSPITAL_TO_COMPARE,
  REMOVE_HOSPITAL_FROM_COMPARE,
  CLEAR_HOSPITALS_COMPARE,
  UPDATE_HOSPITAL_IN_COMPARE,
  ADD_NEW_HOSPITAL,
  REMOVE_EMPTY_HOSPITALS,
} from "./compare.actionTypes";

const initialState = {
  compareHospitals:
    JSON.parse(sessionStorage.getItem("compareHospitals")) || [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_HOSPITAL_TO_COMPARE: {
      const existingProviders = new Set(
        state.compareHospitals.map((h) => h.provider_number),
      );

      const filteredHospitals = action.payload.filter(
        (hospital) => !existingProviders.has(hospital.provider_number),
      );

      const updatedHospitals = [
        ...filteredHospitals,
        ...state.compareHospitals,
      ];

      sessionStorage.setItem(
        "compareHospitals",
        JSON.stringify(updatedHospitals),
      );

      return {
        ...state,
        compareHospitals: updatedHospitals,
      };
    }

    case REMOVE_HOSPITAL_FROM_COMPARE: {
      const idsToRemove = new Set(action.payload);

      const updatedHospitals = state.compareHospitals.filter(
        (hospital) => !idsToRemove.has(hospital.provider_number)
      );

      sessionStorage.setItem(
        "compareHospitals",
        JSON.stringify(updatedHospitals),
      );

      return {
        ...state,
        compareHospitals: updatedHospitals,
      };
    }

    case CLEAR_HOSPITALS_COMPARE:
      sessionStorage.removeItem("compareHospitals");
      return {
        ...state,
        compareHospitals: [],
      };

    case UPDATE_HOSPITAL_IN_COMPARE: {
      const { newHospital, index } = action.payload;
      const updatedCompareHospitals = [...state.compareHospitals];
      updatedCompareHospitals[index] = newHospital;
      sessionStorage.setItem("compareHospitals", JSON.stringify(updatedCompareHospitals));
      return {
        ...state,
        compareHospitals: updatedCompareHospitals,
      };
    }

    case ADD_NEW_HOSPITAL: {
      const index = action.payload;

      const emptyExists = state.compareHospitals.some(
        (hospital) => Object.keys(hospital).length === 0
      );

      if (emptyExists) return state;

      const updatedHospitals = [...state.compareHospitals];
      updatedHospitals.splice(index, 0, {}); 

      return {
        ...state,
        compareHospitals: updatedHospitals,
      };
    }

    case REMOVE_EMPTY_HOSPITALS:
      return {
        ...state,
        compareHospitals: state.compareHospitals.filter(
          (hospital) => Object.keys(hospital).length > 0
        ),
      };

    default:
      return state;
  }
};